import React from 'react';

export default function Logo({ className = "w-10 h-10" }) {
    return (
        <svg className={className} viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{ stopColor: "#00d4d4", stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: "#22c55e", stopOpacity: 1 }} />
                </linearGradient>
            </defs>
            <rect x="70" y="50" width="18" height="140" fill="url(#logoGradient)" rx="9" />
            <path d="M 88 50 Q 120 50 130 70 Q 140 85 135 100" fill="none" stroke="url(#logoGradient)" strokeWidth="18" strokeLinecap="round" />
            <line x1="100" y1="110" x2="160" y2="180" stroke="url(#logoGradient)" strokeWidth="18" strokeLinecap="round" />
            <circle cx="180" cy="60" r="8" fill="#22c55e" opacity="0.8" />
            <circle cx="210" cy="85" r="6" fill="#00d4d4" opacity="0.8" />
            <circle cx="220" cy="120" r="7" fill="#22c55e" opacity="0.8" />
            <line x1="180" y1="60" x2="210" y2="85" stroke="#00d4d4" strokeWidth="2" opacity="0.6" />
            <line x1="210" y1="85" x2="220" y2="120" stroke="#22c55e" strokeWidth="2" opacity="0.6" />
            <rect x="70" y="195" width="100" height="3" fill="url(#logoGradient)" />
        </svg>
    );
}
